<template>
    <cp-grid stretch-content align="center">
        <cp-grid-item :span="renderGifScreen" v-for="gif in gifs" :key="gif.id">
            <img class="gif-image" :src="gif.images.fixed_height.url" alt="" @click="selectGif(gif)" style="cursor: pointer" />
        </cp-grid-item>
    </cp-grid>
</template>

<script>
import CpGrid from '../grid';
import CpGridItem from '../grid-item';

export default {
    name: 'CpListingGif',
    data() {
        return {
            gif: null,
        };
    },
    props: {
        gifs: Array,
        dismissModal: Function,
        selectedGif: Function,
    },
    components: {
        CpGrid,
        CpGridItem,
    },
    computed: {
        renderGifScreen() {
            if (this.$root.isPhone) {
                return 12;
            }
            else if (this.$root.isMobile) {
                return 6;
            }
            else {
                return 3;
            }
        },
    },
    methods: {
        selectGif(gif) {
            this.gif = gif;
            this.selectedGif(this.gif);
            this.dismissModal();

        },
    },
};
</script>

<style scoped>
img.gif-image {
    aspect-ratio: 16 / 9;
    width: 200px;
}
@media only screen and (max-width: 1366px) {
    img.gif-image {
        width: 150px;
    }
}
@media only screen and (max-width: 767px) {
    img.gif-image {
        width: 50px;
    }
}
</style>